import { useEffect, useState } from "react";
import { toast } from "sonner";
import { API, errMsg } from "../lib/api";
import Seo from "../components/Seo";

const FIELD = "w-full border border-stone-300 bg-white rounded-lg px-4 py-3 text-sm outline-none focus:border-[#6A1B29] transition-colors";

export function About() {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 py-16" data-testid="about-page">
      <Seo title="About Suvikka | Women's Lifestyle Retail Brand" description="Learn about Suvikka — a modern pan-India women's fashion, beauty, jewellery and lifestyle retail brand, and our retail outlet opportunity." canonicalPath="/about" />
      <p className="text-xs font-semibold tracking-[0.25em] uppercase text-[#6A1B29]">About Suvikka</p>
      <h1 className="font-display text-4xl sm:text-5xl font-semibold text-stone-900 mt-3">A Modern Indian Women's Lifestyle Retail Brand</h1>
      <div className="text-stone-600 leading-relaxed mt-6 space-y-4">
        <p>SUVIKKA is building a pan-India network of retail outlets focused on trending products for ladies and girls — cosmetics, intimates, jewellery, fashion accessories, bags, belts, hair accessories and seasonal trending items, all under one roof.</p>
        <p>Our retail outlet program lets entrepreneurs bring a Suvikka outlet to their city with an indicative investment of ₹3,00,000/-, covering product inventory, store setup support, branding, marketing and retail guidance.</p>
        <p className="text-sm text-stone-500">Investment amount is indicative and subject to final outlet format, location, product assortment and applicable commercial terms. Business performance depends on location, sales, operating expenses and market conditions. No guaranteed return or profit is promised.</p>
      </div>
    </div>
  );
}

export function Contact() {
  const [f, setF] = useState({ name: "", email: "", mobile: "", message: "" });
  const [sent, setSent] = useState(false);
  const [phone, setPhone] = useState("7633993332");
  useEffect(() => { API.get("/settings/public").then((r) => setPhone(r.data.contact_phone || "7633993332")).catch(() => {}); }, []);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    try { await API.post("/contact", f); setSent(true); toast.success("Message sent"); }
    catch (err) { toast.error(errMsg(err)); }
  };
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 py-16" data-testid="contact-page">
      <Seo title="Contact Suvikka | Outlet Enquiries & Support" description="Get in touch with the Suvikka team for retail outlet enquiries, partnerships and support. Call, WhatsApp or send us a message." canonicalPath="/contact" />
      <p className="text-xs font-semibold tracking-[0.25em] uppercase text-[#6A1B29]">Contact</p>
      <h1 className="font-display text-4xl sm:text-5xl font-semibold text-stone-900 mt-3">Talk To The Suvikka Team</h1>
      <p className="text-stone-500 mt-4">For outlet enquiries, call or WhatsApp: <a href={`tel:${phone}`} className="text-[#6A1B29] font-semibold" data-testid="contact-phone">{phone}</a></p>
      {sent ? <p className="mt-8 text-green-700 bg-green-50 border border-green-200 rounded-xl p-5" data-testid="contact-success">Thank you. We will get back to you shortly.</p> : (
        <form onSubmit={submit} className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-8 max-w-2xl" data-testid="contact-form">
          <input required placeholder="Name" value={f.name} onChange={set("name")} className={FIELD} data-testid="contact-name" />
          <input required type="email" placeholder="Email" value={f.email} onChange={set("email")} className={FIELD} data-testid="contact-email" />
          <input placeholder="Mobile" value={f.mobile} onChange={set("mobile")} className={FIELD} data-testid="contact-mobile" />
          <textarea required placeholder="Message" rows={4} value={f.message} onChange={set("message")} className={`${FIELD} sm:col-span-2`} data-testid="contact-message" />
          <button className="sm:col-span-2 bg-[#6A1B29] hover:bg-[#501325] text-white font-semibold py-3.5 rounded-full" data-testid="contact-submit">SEND MESSAGE</button>
        </form>
      )}
    </div>
  );
}

export function AffiliateTerms() {
  const [terms, setTerms] = useState("");
  useEffect(() => { API.get("/settings/public").then((r) => setTerms(r.data.affiliate_terms || "")).catch(() => {}); }, []);
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16" data-testid="affiliate-terms-page">
      <Seo title="Affiliate Program Terms | Suvikka" description="Read the Suvikka Affiliate Program terms and conditions, including eligibility and referral commission policy." canonicalPath="/affiliate-terms" />
      <p className="text-xs font-semibold tracking-[0.25em] uppercase text-[#6A1B29]">Legal</p>
      <h1 className="font-display text-4xl sm:text-5xl font-semibold text-stone-900 mt-3">Affiliate Program Terms</h1>
      <div className="mt-8 text-stone-600 leading-relaxed whitespace-pre-line text-sm sm:text-base" data-testid="affiliate-terms-content">
        {terms || "Loading terms…"}
      </div>
      <p className="mt-8 text-xs text-stone-500 bg-stone-100 rounded-xl p-4">Affiliates must not make false claims such as "Guaranteed ₹30,000 income". Approved marketing language: "Earn 10% referral commission on eligible successful outlet conversions."</p>
    </div>
  );
}
